import { TENANT_STORAGE_KEY } from '../config/tenants';
import { Tenant } from '../types/tenant';

type TenantAction =
  | { type: 'SET_CURRENT_TENANT'; payload: Tenant | null }
  | { type: 'SET_AVAILABLE_TENANTS'; payload: Tenant[] }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'CLEAR_TENANT' };

// Função auxiliar para carregar tenant do localStorage
export const loadStoredTenant = (dispatch: React.Dispatch<TenantAction>, availableTenants: Tenant[]) => {
  try {
    const storedTenantName = localStorage.getItem(TENANT_STORAGE_KEY);
    if (storedTenantName) {
      // Tenta encontrar o tenant pelo nome
      const tenant = availableTenants.find(t => t.name === storedTenantName);
      if (tenant) {
        dispatch({ type: 'SET_CURRENT_TENANT', payload: tenant });
        return;
      } else {
        // Se não encontrou, limpa o localStorage (pode ser um ID antigo salvo)
        console.log(`Tenant '${storedTenantName}' não encontrado na lista de tenants disponíveis. Limpando localStorage.`);
        localStorage.removeItem(TENANT_STORAGE_KEY);
      }
    }

    // Se não há tenant armazenado e há tenants disponíveis, usar o primeiro
    if (availableTenants.length > 0) {
      const firstTenant = availableTenants[0];
      dispatch({ type: 'SET_CURRENT_TENANT', payload: firstTenant });
      localStorage.setItem(TENANT_STORAGE_KEY, firstTenant.name);
    }
  } catch (error) {
    console.error('Erro ao carregar tenant do localStorage:', error);
    // Em caso de erro, usar o primeiro tenant disponível
    if (availableTenants.length > 0) {
      const firstTenant = availableTenants[0];
      dispatch({ type: 'SET_CURRENT_TENANT', payload: firstTenant });
    }
  } finally {
    // Sempre definir loading como false após tentar carregar o tenant
    dispatch({ type: 'SET_LOADING', payload: false });
  }
};
